'use strict';

goog.provide("Ntry.Bitmap");

goog.require("Ntry.STATIC");

Ntry.Bitmap = function(bitmap) {
    this.image = bitmap.image || "wall_12";

    this.regX = bitmap.regX;

    this.regY = bitmap.regY;

    this.rotation = bitmap.rotation ? bitmap.rotation : 0;

    this.opacity = bitmap.opacity ? bitmap.opacity : 1;

    this.scaleX = bitmap.scaleX ? bitmap.scaleX : 1;

    this.scaleY = bitmap.scaleY ? bitmap.scaleY : 1;
}

Ntry.Bitmap.prototype.type =
    Ntry.STATIC.BITMAP;
